import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import SvgIcon from "@mui/material/SvgIcon";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import LogoImage from "../../assets/logo.svg?react";
import {
  bottomSectionSx,
  copyrightTextSx,
  dividerSx,
  footerContentSx,
  getFooterSx,
  footerLogoImageSx,
  legalLinkSx,
  legalLinksSx,
  logoSectionSx,
  sloganSx,
} from "./Footer.sx";
import { LEGAL_LINKS } from "./Footer.config";

interface FooterProps {
  backgroundColor?: string;
}

export function Footer({ backgroundColor }: FooterProps) {
  return (
    <Box component="footer" sx={getFooterSx(backgroundColor)}>
      <Stack sx={footerContentSx}>
        <Divider sx={dividerSx} />

        {/* Logo Section with Slogan */}
        <Stack sx={logoSectionSx}>
          <SvgIcon
            component={LogoImage}
            inheritViewBox
            sx={footerLogoImageSx}
          />
          <Typography sx={sloganSx}>
            CERN Expertise and Real-World AI Solutions
          </Typography>
        </Stack>

        {/* Bottom Section: Copyright and Legal Links */}
        <Box sx={bottomSectionSx}>
          <Typography sx={copyrightTextSx}>
            Copyright by © {new Date().getFullYear()} CLEDAR Co.
          </Typography>
          <Box sx={legalLinksSx}>
            {LEGAL_LINKS.map((link) => (
              <Box
                key={link.label}
                component="a"
                href={link.href}
                sx={legalLinkSx}
              >
                {link.label}
              </Box>
            ))}
          </Box>
        </Box>
      </Stack>
    </Box>
  );
}

export default Footer;
